import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";

export default function Cancel() {
    return (
        <div className="min-h-screen bg-brand-cream flex items-center justify-center p-6">
            <div
                className="max-w-lg w-full bg-white rounded-2xl shadow-pop p-8 md:p-12 text-center"
                data-testid="checkout-cancel-page"
            >
                <div className="mx-auto h-20 w-20 rounded-full bg-brand-orange-soft flex items-center justify-center">
                    <XCircle className="h-10 w-10 text-brand-orange" />
                </div>
                <h1 className="mt-6 font-display font-medium text-3xl md:text-4xl text-brand-ink">
                    Pagamento cancelado
                </h1>
                <p className="mt-3 text-brand-ink-soft">
                    Não te preocupes — o teu carrinho continua à tua espera.
                </p>
                <Link
                    to="/"
                    data-testid="cancel-back-home"
                    className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-green hover:bg-brand-green-dark text-white px-6 py-3 text-sm font-semibold transition-colors"
                >
                    <ArrowLeft className="h-4 w-4" /> Voltar à loja
                </Link>
            </div>
        </div>
    );
}
